var bannerSwiper = [];
var bannerSwiperIndex = 0;
export default ({
    name : 'BannerZone'
    , props : {
        isUseCategoryByObserver : Boolean
    }
    , data () {
        return {
            originBannerList : []
            , bannerCount : 0
        }
    }
    , created () {
        this.code = 'banner_zone';
        this.basic = this.getDetailDataByCode(this.code);
        this.originBannerList = this.basic.data.banner_image.value
        this.bannerWrap = `.js-${this.code}-wrap`
        return {}
    }
    , mounted () {
    }
    , computed : {
        bannerList () {
            this.fileterCurrentBannerImageDefault()
            let bannerData = this.basic.data
            let maxCnt = bannerData.banner_max_cnt.value;
            let list = []
            let originList = []
            for (let key in bannerData.banner_image.value) {
                if (bannerData.banner_image.value[key].length < 1) { continue; }
                if (maxCnt <= list.length) { break; }
                let link = this.getBannerLink(bannerData.banner_link_type.value[key], bannerData.banner_link.value[key], bannerData.banner_link_id.value[key]);
                let item = {
                    'image' : bannerData.banner_image.value[key]
                    , 'link' : link.link
                    , 'target' : link.target
                    , 'code' : this.code
                }
                list.push(item)
                originList.push(bannerData.banner_image.value[key])
            }
            this.bannerCount = list.length
            return list
        }
    }
    , methods : {
        fileterCurrentBannerImageDefault () {
            if (this.isEmptyBannerImage()) {
                if (this.isEmptyBannerDefault()) {
                    return []
                }
                this.basic.data.banner_image.value = this.basic.data.banner_image.default
            }
        }
        , isMultipleBanner () {
            return (this.bannerCount > 1) 
        }
        , isEmptyBannerDefault () {
            let bannerData = this.basic.data;
            return (bannerData.banner_image.default.length == 0)
        }
        , isEmptyBannerImage () {
            let bannerData = this.basic.data;
            if (bannerData.banner_image.value.length == 0) return true
            let list = []
            for (let key in bannerData.banner_image.value) {
                if (bannerData.banner_image.value[key].length > 0) {
                    list.push(bannerData.banner_image.value[key])
                }
            }
            return (list.length < 1)
        }
        , setSwipe () {
            let option = {
                initialSlide : 0
                , loop: true
                , autoplay: {
                    delay: 3000
                }
                , slidesPerView: 1
                , pagination: {
                    el: '.swiper-pagination',
                }
                , autoHeight : true
                , a11y : false
            }
            this.deleteSwipe()
            let wrap = $m(this.bannerWrap)
            let bannerTpl = $m('.banner-slide-tpl', wrap).html()
            // TODO..
            if (templateType == 'blog') {
                bannerTpl = `<div class="swiper-container banner-slide">${bannerTpl}</div>`
            } else if (templateType == 'shop') {
                bannerTpl = `<div class="visualTop swiper-container banner-slide ${this.getUseCategoryClass()}">${bannerTpl}</div>`
            }
            wrap.append(bannerTpl);
            bannerSwiper[bannerSwiperIndex] = new Swiper(this.bannerWrap+' .banner-slide', option);
            bannerSwiperIndex++;
            if (this.getAdminEditMode()) {
                this.areaSettingDisplayNone()
            }
        }
        , deleteSwipe () {
            $m(this.bannerWrap+' .banner-slide').remove()
            if (bannerSwiperIndex > 0) {
                let bannerSwiperIndexPre = parseInt(bannerSwiperIndex) - 1
                if (bannerSwiper[bannerSwiperIndexPre]) { delete bannerSwiper[bannerSwiperIndexPre] }
            }
        }
        , bannerSwipe () {
            if (this.isMultipleBanner()) {
                this.setSwipe()
                return
            }
            this.deleteSwipe()
        }
        , areaSettingDisplayNone() {
            let btn = document.querySelectorAll('.visualTop .btn-area-setting')
            let border = document.querySelectorAll('.visualTop .section-border')
            for (let i=0; i<btn.length; i++) {
                btn[i].style.display = 'none'
            }
            for (let j=0; j<border.length; j++) {
                border[j].style.display = 'none'
            }
        }
        , getUseCategoryClass () {
            let className = 'none-category';
            if (this.isUseCategoryByObserver === true) {
                className = 'use-category';
            }
            return className
        }
        , checkOriginBannerList (bannerImage) {
            let chk = true
            if (this.originBannerList.length == 0) return false
            for (let i in bannerImage) {
                for (let j in this.originBannerList) {
                    if (this.originBannerList[j].includes(bannerImage[i]) === false) {
                        chk = false
                        break
                    }
                }
                if (chk === false) break
            }
            return chk
        }
    }
    , updated () {
        if (this.checkOriginBannerList(this.basic.data.banner_image.value) === false) {
            this.originBannerList = this.basic.data.banner_image.value
            this.bannerSwipe()
        }
    }
})
